import * as React from "react";
import DropdownDataInput, { SizedDropdownDataInput } from "../../dropdownDataInput/DropdownDataInput";
import SizedDateDataInput from "../../dateDataInput/DateDataInput";
import { WideActionButton } from "../../actionButton/ActionButton";
import { updateSelectionCriteria } from "../../../../redux/reducers/RepertoireReducer";
import { IDistributionPoolState } from "../../../../redux/types/IDistributionPoolState";
import { ISelectionCriteria, ISelectionCriteriaDateRange, ISelectionCriteriaDistPoolSegment } from "../../../types/ISelectionCriteria";
import DataGridTable from "../../dataGridTable/DataGridTable";
import { ADD_NEW_ACTION, DATE_INPUT, DISTRIBUTION_POOLS_KEY, DISTRIBUTION_POOL_DATE_RANGE_SELECTION_CRITERIA_KEY, DISTRIBUTION_POOL_DATE_RANGE_SELECTION_CRITERIA_STATE_KEY, DISTRIBUTION_POOL_SELECTION_CRITERIA_KEY, DISTRIBUTION_POOL_SELECTION_CRITERIA_STATE_KEY, DROPDOWN_INPUT } from "../../../Consts";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IDataItem } from "../../../types/usageTypes/IDataItem";
import { IDistPoolSegmentDataItems } from "../../../types/IDistPoolSegmentDataItems";
import {IDateRangeDataItems} from "../../../types/IDateRangeDataItems";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { IDistribution } from "../../../types/usageTypes/IDistribution";
import CheckboxDataInput from "../../checkboxDataInput/CheckboxDataInput";
import { SizedTextDataInput } from "../../textDataInput/TextDataInput";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { If } from "../../../../core/components/If";
import {
    ARTISJUS_CUSTOMER_NAME,
    KODA_CUSTOMER_NAME,
    SPANISH_POINT_CUSTOMER_NAME,
    TEOSTO_CUSTOMER_NAME, TONO_CUSTOMER_NAME
} from "../../../../home/Consts";
import { SizedRadiobuttonDataInput } from "../../radioButtonDataInput/RadiobuttonDataInput";
import {getLookupValues} from "../../../../lookup/services/LookupHelpers";
import {
    CATCH_UP_TYPE,
} from "../../../../lookup/Consts";

export interface ISelectionCriteriaViewProps {
    distributionPool: IDistributionPoolState;
    hideModal: () => void;
    updateSelectionCriteria: typeof updateSelectionCriteria;
    dataGridTableData: IRepertoireComponentDataItem,
    lookupValues: ILookupDictionary;
    distributions?: IDistribution[];
    isReadOnly?: boolean;
    tabs?: ITabReduxItem[];
    activeTab?: number;
    incrementTempID?: () => void;
    getAllowFileSelectInSelectionCriteria: () => void;
    allowFileSelect: boolean;
    customer?: string;
    getUsagePoolsByDistribution?: (distributionId: number) => any;
    isCatchupAllocationsEnabled?: boolean;
}

interface ISelectionCriteriaViewState {
    selectionCriteria: ISelectionCriteria;
    pools: Array<{
        code: string;
        description: string;
        extraFields: any;
    }>;
}


class SelectionCriteriaView extends React.PureComponent<ISelectionCriteriaViewProps, ISelectionCriteriaViewState> {

    constructor(props: ISelectionCriteriaViewProps) {
        super(props);
        this.state = {
            selectionCriteria: this.props.distributionPool.selectionCriteria,
            pools: [],
        }
    }

    componentDidMount() {
        const { distributionPool, getAllowFileSelectInSelectionCriteria } = this.props;
        if (distributionPool.selectionCriteria) {
            const initialState = {
                selectionCriteria: {
                    ...distributionPool.selectionCriteria,
                    dateRanges: distributionPool.selectionCriteria.dateRanges || [],
                    distPoolSegments: distributionPool.selectionCriteria.distPoolSegments || []
                }
            };

            this.setState(initialState, () => {
                if (this.state.selectionCriteria.catchupDistributionId) {
                    this.loadPools(this.state.selectionCriteria.catchupDistributionId);
                }
            });


            getAllowFileSelectInSelectionCriteria();

        }
    } 

    componentDidUpdate(prevProps: ISelectionCriteriaViewProps, prevState: ISelectionCriteriaViewState) {
        const { selectionCriteria } = this.state;
        if (prevState.selectionCriteria.catchupDistributionId !== selectionCriteria.catchupDistributionId) {
            this.loadPools(selectionCriteria.catchupDistributionId);
        }
    }
    
    handleCatchUp = () => {
        const { selectionCriteria } = this.state;
        if (selectionCriteria.isCatchupEnabled)
        {
            selectionCriteria.isDateRangeEnabled = false;
            selectionCriteria.isPoolSegmentEnabled = false;
            selectionCriteria.isCustomQueryEnabled = false;
            selectionCriteria.revertSourceUsageMultipliers = false;
            selectionCriteria.isFileNameEnabled = false;
        }
    }
    
    loadPools = (distributionId) => {
        if (distributionId) {
            const { getUsagePoolsByDistribution } = this.props;
            getUsagePoolsByDistribution(distributionId)
                .then((res) => {
                    const pools = Array.isArray(res) ? res : [];
                    this.setState(prevState => ({
                        ...prevState,
                        pools: pools.map(pool => ({
                            code: pool.poolCode,
                            description: pool.description,
                            extraFields: null
                        }))
                    }));
                })
                .catch((error: any) => {
                    this.setState(prevState => ({
                        ...prevState,
                        pools: []
                    }));
                });
        } else {
            this.setState(prevState => ({
                ...prevState,
                pools: []
            }));
        }
    }



    
    updateSelectionCriteriaState = (value: any, field: string) => {
        switch (field) {
            case "Type":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        type: value,

                    }
                }));
                break;
            case "DateRange":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        isDateRangeEnabled: value
                    }
                }));
                break;
            case "PoolSegment":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        isPoolSegmentEnabled: value
                    }
                }));
                break;
            case "CustomQuery":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        isCustomQueryEnabled: value
                    }
                }));
                break;
            case "CustomQueryText":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        customQuery: value
                    }
                }));
                break;
            case "isFileNameEnabled":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        isFileNameEnabled: value
                    }
                }));
                break;
            case "fileName":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        fileName: value
                    }
                }));
                break;
            case "SourceUsageMultipliers":
                value = (value === "revertSourceUsageMultipliers")
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        revertSourceUsageMultipliers: value
                    }
                }));
                break;
            case "isCatchupEnabled":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        isCatchupEnabled: value
                    }
                }), () => {
                    this.handleCatchUp();
                });
                break;
            case "catchupType":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        catchupType: value
                    }
                }));
                break;
            case "catchupDistributionId":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        catchupDistributionId: value,
                        catchupPoolId: null
                    }
                }), () => {
                    this.loadPools(value);
                });
                break;
            case "catchupPoolId":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        catchupPoolId: value
                    }
                }));
                break;
            case "PoolDateReference":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        isPoolDateReferenceEnabled: value
                    }
                }));
                break;
            case "PoolDateReferenceInput":
                this.setState(prevState => ({
                    selectionCriteria: {
                        ...prevState.selectionCriteria,
                        poolDateReference: value
                    }
                }));
                break;
        }
    };
    
    updateDistPoolSegment = (value: IDistPoolSegmentDataItems[], name: string) => {

        let distPoolSegments: ISelectionCriteriaDistPoolSegment[] = value.map((dsp) => ({
            distribution: dsp.distribution.value,
            pool: dsp.pool.value,
            segment: dsp.segment.value,
            id: dsp.distPoolSegmentID
        }));
        this.setState((prevState) => ({
            selectionCriteria: {
                ...prevState.selectionCriteria,
                distPoolSegments
            }
        }));

    }

    updateDateRanges = (value: IDateRangeDataItems[]) => {

        let dateRanges: ISelectionCriteriaDateRange[] = value.map((dsp) => ({
            fromDate:dsp.fromDate.value,
            toDate:dsp.toDate.value,
            id: dsp.dateRangeSegmentID
        }));
        this.setState((prevState) => ({
            selectionCriteria: {
                ...prevState.selectionCriteria,
                dateRanges
            }
        }));

    }

    renderDistPoolSegmentSection = () => {
        const { dataGridTableData, lookupValues, distributions, isReadOnly,tabs, activeTab,incrementTempID} = this.props;
        const { selectionCriteria: { distPoolSegments } } = this.state;
        let dataItems: IDistPoolSegmentDataItems[] = distPoolSegments.map((dsp) => ({
            distPoolSegmentID: dsp.id,
            distribution: { inputType: DROPDOWN_INPUT, value: dsp.distribution || '' },
            pool: { inputType: DROPDOWN_INPUT, value: dsp.pool || '' },
            segment: { inputType: DROPDOWN_INPUT, value: dsp.segment || '' }
        }));

        return (
            <DataGridTable
                tableContents={dataItems}
                changeData={this.updateDistPoolSegment}
                dataGridTableData={dataGridTableData}
                stateKey={DISTRIBUTION_POOL_SELECTION_CRITERIA_STATE_KEY}
                componentInstance={DISTRIBUTION_POOL_SELECTION_CRITERIA_KEY}
                showRowNumber={false}
                isReadOnly={isReadOnly}
                tableActions={[{ name: ADD_NEW_ACTION }]}
                lookupValues={lookupValues}
                distributions={distributions}
                tabs={tabs}
                activeTab={activeTab}
                incrementTempID={incrementTempID}
            />
        )
    }
    
    mapDistributioonsToDropdown = (distributions: IDistribution[]) => {
        return distributions.map(distribution => ({
            code: distribution.distributionID.toString(),
            description: distribution.distributionCode,
            extraFields: null
        }));
    }

    renderDateRangeSection = () => {
        const { dataGridTableData, lookupValues, isReadOnly,tabs,activeTab,incrementTempID, isCatchupAllocationsEnabled } = this.props;
        const { selectionCriteria: { dateRanges } } = this.state;
        let dataItems: IDateRangeDataItems[] = dateRanges.map((dsp) => ({
            fromDate:{inputType: DATE_INPUT, value: dsp.fromDate || '' },
           toDate:{inputType: DATE_INPUT, value: dsp.toDate || ''},
           dateRangeSegmentID: dsp.id,
        }));
        return (
            <DataGridTable
                tableContents={dataItems}
                changeData={this.updateDateRanges}
                dataGridTableData={dataGridTableData}
                stateKey={DISTRIBUTION_POOL_DATE_RANGE_SELECTION_CRITERIA_STATE_KEY}
                componentInstance={DISTRIBUTION_POOL_DATE_RANGE_SELECTION_CRITERIA_KEY}
                showRowNumber={false}
                isReadOnly={isReadOnly}
                tableActions={[{ name: ADD_NEW_ACTION }]}
                lookupValues={lookupValues}
                tabs={tabs}
                activeTab={activeTab}
                incrementTempID={incrementTempID}
            />
        )
    }
    
    render(): React.ReactNode {
        const { selectionCriteria } = this.state;
        const { distributionPool, distributions, updateSelectionCriteria, hideModal, isReadOnly, customer, isCatchupAllocationsEnabled, allowFileSelect } = this.props;
        let buttonAction = () => {
            updateSelectionCriteria(distributionPool.distributionPoolID, selectionCriteria);
            hideModal();
        };

        const distributionsForPools = distributions.find(d => d.distributionID == selectionCriteria?.catchupDistributionId);
        let poolOptions = [];
        if (distributionsForPools) {
            poolOptions = distributionsForPools.distributionPools.map(pool => {
                return {
                    code: pool.poolID.toString(), 
                    value: pool.poolCode,   
                    description: pool.poolCode,
                }
            });
        }

        const disableSelectionCriteria = selectionCriteria.isCatchupEnabled || selectionCriteria.isFileNameEnabled;
        const isPoolDateReferenceHidden = customer !== ARTISJUS_CUSTOMER_NAME;
        if (selectionCriteria) {
            return (
                <div className="col-md-12">
                    <div className="selectionCriteriaOptions">
                        <CheckboxDataInput
                            label="Date Range"
                            fieldName=""
                            value={selectionCriteria.isDateRangeEnabled}
                            changeData={(value) => this.updateSelectionCriteriaState(value, "DateRange")}
                            readonly={disableSelectionCriteria}
                            isHidden={false}
                        />
                           {selectionCriteria.isDateRangeEnabled && !selectionCriteria.isCatchupEnabled && !selectionCriteria.isFileNameEnabled &&
                             <div className="row">
                             {this.renderDateRangeSection()}
                            </div>
                        }
                        <CheckboxDataInput
                            label="Pool Date Reference"
                            fieldName=""
                            value={selectionCriteria.isPoolDateReferenceEnabled}
                            changeData={(value) => this.updateSelectionCriteriaState(value, "PoolDateReference")}
                            isHidden={isPoolDateReferenceHidden}
                        />
                           {selectionCriteria.isPoolDateReferenceEnabled &&
                            <div className="row">
                            <SizedDateDataInput
                                    fieldType={""}
                                    useEnterSubmit={true}
                                    label=""
                                    fieldName={""}
                                    changeData={(value) => this.updateSelectionCriteriaState(value, "PoolDateReferenceInput")}
                                    value={selectionCriteria.poolDateReference}
                                    isHidden={false}
                                /> 
                        </div>
                        }
                        <CheckboxDataInput
                            label="Distribution/Pool/Segment"
                            fieldName=""
                            value={selectionCriteria.isPoolSegmentEnabled}
                            changeData={(value) => this.updateSelectionCriteriaState(value, "PoolSegment")}
                            readonly={disableSelectionCriteria}
                            isHidden={false}
                        />
                        {selectionCriteria.isPoolSegmentEnabled && !selectionCriteria.isCatchupEnabled && !selectionCriteria.isFileNameEnabled &&
                            <div className="row">
                                {this.renderDistPoolSegmentSection()}
                            </div>
                        }
                        <CheckboxDataInput
                            label="Custom Query"
                            fieldName=""
                            value={selectionCriteria.isCustomQueryEnabled}
                            changeData={(value) => this.updateSelectionCriteriaState(value, "CustomQuery")}
                            readonly={disableSelectionCriteria}
                            isHidden={false}
                        />
                        {selectionCriteria.isCustomQueryEnabled && !selectionCriteria.isFileNameEnabled &&
                        <div className="row">
                            <SizedTextDataInput
                                    fieldType={""}
                                    useEnterSubmit={true}
                                    label=""
                                    fieldName={""}
                                    changeData={(value) => this.updateSelectionCriteriaState(value, "CustomQueryText")}
                                    value={selectionCriteria.customQuery}
                                    isHidden={false}
                                    readOnly={disableSelectionCriteria}
                                /> 
                        </div>
                        }
                        <If condition={allowFileSelect}>
                            <>
                                <CheckboxDataInput
                                    label="File Name"
                                    fieldName=""
                                    value={selectionCriteria.isFileNameEnabled}
                                    changeData={(value) => this.updateSelectionCriteriaState(value, "isFileNameEnabled")}
                                    readonly={selectionCriteria.isCatchupEnabled}
                                    isHidden={false}
                                />
                                {selectionCriteria.isFileNameEnabled && 
                                <div className="row">
                                    <SizedTextDataInput
                                            fieldType={""}
                                            useEnterSubmit={true}
                                            label=""
                                            fieldName={""}
                                            changeData={(value) => this.updateSelectionCriteriaState(value, "fileName")}
                                            value={selectionCriteria.fileName}
                                            isHidden={false}
                                            handleKeyDown={(e) => { }}
                                            readOnly={selectionCriteria.isCatchupEnabled}
                                        /> 
                                </div>
                                }
                                </>
                        </If>
                        <If condition={isCatchupAllocationsEnabled}>
                            <>
                                <CheckboxDataInput
                                    label="Allocate additional product repertoire works"
                                    fieldName="isCatchupEnabled"
                                    value={selectionCriteria.isCatchupEnabled}
                                    changeData={value => this.updateSelectionCriteriaState(value, "isCatchupEnabled")}
                                    readonly={selectionCriteria.isFileNameEnabled}
                                    isHidden={false}
                                />
                                {selectionCriteria.isCatchupEnabled &&
                                    <div className="row">
                                        <DropdownDataInput
                                            label=""
                                            fieldName={"catchupType"}
                                            changeData={(value) => this.updateSelectionCriteriaState(value, "catchupType")}
                                            value={selectionCriteria.catchupType}
                                            isHidden={!isCatchupAllocationsEnabled}
                                            options={[
                                                {description: "Partial cue-sheets", code: "PartialCuesheets"},
                                                {description: "Fully identified cue-sheets", code: "AdditionalWorks"},
                                                {description: "Both", code: "Both"},
                                            ]}
                                            allowNull={!isCatchupAllocationsEnabled}
                                        />
                                    </div>
                                }
                                {selectionCriteria.isCatchupEnabled &&
                                <>
                                    <div className="row">
                                            <DropdownDataInput
                                             label="Distribution"
                                             fieldName="catchupDistributionId"
                                             changeData={(value) => this.updateSelectionCriteriaState(value, "catchupDistributionId")}
                                             value={selectionCriteria.catchupDistributionId}
                                             isHidden={false}
                                             options={this.mapDistributioonsToDropdown(distributions) || []}
                                             allowNull={false}
                                            />
                                        </div>
                                        <div className="row">
                                            <DropdownDataInput
                                                value={selectionCriteria.catchupPoolId}
                                                label="Pool"
                                                changeData={(value) => {
                                                    this.updateSelectionCriteriaState(value, "catchupPoolId");
                                                }}
                                                fieldName={"pool"}
                                                options={poolOptions || []}
                                                allowNull={false}
                                                isHidden={false}
                                            />
                                        </div>
                                 </>
                                }
                            </>
                        </If>
                        <SizedRadiobuttonDataInput
                            key={"sourceUsageMultipliers"}
                            selectedValue={
                                selectionCriteria.revertSourceUsageMultipliers ?
                                    "revertSourceUsageMultipliers" :
                                    "keepSourceUsageMultipliers"
                            }
                            disabled={disableSelectionCriteria}
                            onSelectionChange={(value) => this.updateSelectionCriteriaState(value, "SourceUsageMultipliers")}
                            radioName="keepSourceUsageMultipliers"
                            title="Source Usage Multipliers"
                            options={[
                                { desc: "Revert Source Usage multipliers", code: "revertSourceUsageMultipliers" },
                                { desc: "Keep Source Usage multipliers", code: "keepSourceUsageMultipliers" },
                            ]}
                        />

                        <div className="row">
                            <WideActionButton
                                buttonText="OK"
                                buttonAction={buttonAction}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
            );
        }
        else return <div></div>
    }



};

export default SelectionCriteriaView;